

import SmoothScroll from './smooth-scroll';
import LogoPageScroll from './logo-page-scroll';
import HamburgerScrollButton from './hamburger-scroll-button';
import VerticalSectionNavigation from './vertical-section-navigation';
import GetInTouchForm from './get-in-touch-form';
import newsletterSubscription from './newsletter-subscription';

import Ticker from './ticker-intrinio';

require('../scss/index.scss');


(function ($) {
  $.fn.hasAttr = function (name) {
    return this.attr(name) !== undefined;
  };

  Ticker();
  $('.js-smooth-scroll').on('click', SmoothScroll);

  const sections = $('section');
  const $hamburger = $('.top-header .navigation-outer');
  const $siteNavigation = $('.js-side-navigation ul');
  const $sectionContainer = $('#js-section-container');

  const totalSections = $sectionContainer.attr('data-total-sections');

  LogoPageScroll();
  VerticalSectionNavigation($siteNavigation, sections, totalSections);
  handleOverviewLinksWithSectionHash();
  stopHomepageBottomSpriteAnimation();
  newsletterSubscription();

  $(document).on('scroll', (e) => {
    LogoPageScroll();
    HamburgerScrollButton($hamburger, sections);
    VerticalSectionNavigation($siteNavigation, sections, totalSections);
    stopHomepageBottomSpriteAnimation();
  });

  $('.js-top-menu-toggle').on('click', function (e) {
    e.preventDefault();
    e.stopPropagation();
    if ($(this).hasClass('active')) {
      $(this).removeClass('active');
      $('.js-overlay').removeClass('open');
      $('body').removeClass('overlay-menu-open');
    } else {
      $(this).addClass('active');
      $('.js-overlay').addClass('open');
      $('body').addClass('overlay-menu-open');
    }
  });

  const $aboutpage = $('.about-page');

  if ($aboutpage && $aboutpage.length > 0) {
    GetInTouchForm();
  }

})(jQuery);

function isScrolledIntoView(elem) {
  var docViewTop = $(window).scrollTop();
  var docViewBottom = docViewTop + $(window).height();

  var elemTop = $(elem).offset().top;
  var elemBottom = elemTop + $(elem).height();

  return ((elemBottom <= docViewBottom) && (elemTop >= docViewTop));
}

function stopHomepageBottomSpriteAnimation() {
  $('.js-animate-on-view').each(function () {
    if ($(this).hasClass('.active')) {
      return;
    }
    if (isScrolledIntoView(this) === true) {
      setTimeout(() => {
        $(this).addClass('active');
      }, 500);
    }
  });
}

function handleOverviewLinksWithSectionHash() {
  $('.js-overlay .overlay-menu li a').bind('click', function (e) {
    removeOverlayMenu();
  });
}



function toggleOverlayMenu() {
  if ($('.js-top-menu-toggle').hasClass('active')) {
    $('.js-top-menu-toggle').removeClass('active');
    $('.js-overlay').removeClass('open');
    $('body').removeClass('overlay-menu-open');
  } else {
    $('.js-top-menu-toggle').addClass('active');
    $('.js-overlay').addClass('open');
    $('body').addClass('overlay-menu-open');
  }
}

function removeOverlayMenu() {
  $('.js-overlay').removeClass('open');
  $('body').removeClass('overlay-menu-open');
  $('.js-top-menu-toggle').removeClass('active');
}
